module.exports = __webpack_public_path__ + "img/xccyrc.2ee1308b.png";